import React, { useState } from "react";
import CustomPopover from "../../popover/Popover";
import CustomButton from "../button/Button";
import { ArrowDownMedium, MonthIcon, QuarterIcon, YearIcon } from "../../../modules/default-svg";
import styles from "../../Export/ReportButton.module.scss";

// GanttViewMode enum values understood by the backend.
const VIEW_MODES = [
  { mode: 2, label: "Month", icon: <MonthIcon /> },
  { mode: 3, label: "Quarter", icon: <QuarterIcon /> },
  { mode: 4, label: "Year", icon: <YearIcon /> },
];

/**
 * "View" dropdown (Month / Quarter / Year) choosing the time scale of a report Gantt. The menu is
 * rendered inline (not portaled) so it also works inside the WSR report-options menus, where a
 * click in a portaled surface would count as an outside click and close the parent menu.
 */
export default function GanttViewModeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const selected = VIEW_MODES.find((v) => v.mode === value) ?? VIEW_MODES[0];

  return (
    <div className="d-flex row align-items-center" onClick={(e) => e.stopPropagation()}>
      <div className="col-3">View</div>
      <div className="col-9 align-items-center">
        <CustomPopover
          inline
          icon={
            <CustomButton
              icon={selected.icon}
              label={selected.label}
              btnClass={`${styles.calendarBtn} d_btn`}
              rightIcon={
                <span className="ms-6 d-inline-flex">
                  <ArrowDownMedium />
                </span>
              }
              clickHandler={() => setOpen((prev) => !prev)}
            />
          }
          width="140px"
          PopSurfaceClass={styles.calendarPopover}
          status={open}
        >
          {VIEW_MODES.map((v) => (
            <div
              key={v.mode}
              className={styles.calendarPopoverItem}
              onClick={() => {
                onChange(v.mode);
                setOpen(false);
              }}
            >
              {v.icon}
              {v.label}
            </div>
          ))}
        </CustomPopover>
      </div>
    </div>
  );
}
